import { useQuery } from 'react-query';

import * as Api from '../api';
import * as Constants from '../constants';
import * as Mappers from '../mappers';

const useSingle = ({ id }) => {
  const initialData = { item: Mappers.FunctionRegister() };

  const { data = initialData, ...args } = useQuery(
    [Constants.ENTITY, 'single', id],
    async () => {
      const { data } = await Api.Single({ id });

      return {
        item: Mappers.FunctionRegister(data && data.data)
      };
    },
    { initialData, enabled: !!id }
  );

  return { ...args, ...data };
};

export default useSingle;
